import $ from 'jquery';

$(document).ready(function() {
	$('.js-sl-zoom').slick({
		infinite: false,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
        arrows: true,
        dots: false,

        prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"></button>'
	  });
});



// WEBPACK FOOTER //
// ./src/js/pages/page-video/sl-zoom.js